import React from "react";
import ProfileCard from "../components/ProfileCard";
import profilesData from "../data/profiles.json";

const Tonex: React.FC = () => {
  const tonexProfiles = profilesData.filter(
    (profile) => profile.type === "tonex"
  );

  return (
    <div className="container mx-auto p-8 text-white max-w-[1280px]">
      <section className="py-5 text-center">
        <h1 className=" text-4xl md:text-6xl  lg:text-8xl font-bold gradient-text-tonex mb-0 lg:mb-20">
          Tonex Tone Models
        </h1>
        <p className="opacity-70 mt-4  lg:text-xl">
          Unlock the Legendary Tones of Mesa Boogie and Diezel with Premium
          TONEX Tone Models. Explore our extensive collection of meticulously
          crafted TONEX captures, designed to bring the iconic sounds of these
          high-gain amplifiers directly to your digital rig. Whether you're
          chasing the crushing rhythm of a Mesa Boogie Mark II or the articulate
          leads of a Einstein, our TONEX profiles deliver authentic and
          inspiring tones for your IK Multimedia TONEX pedal or software.
        </p>
      </section>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-8">
        {tonexProfiles.map((profile) => (
          <ProfileCard key={profile.id} profile={profile} />
        ))}
      </div>{" "}
      <section className="mt-8 text-center max-w-[800px] mx-auto">
        <p className="text-sm opacity-50 ">
          PWC Profiles is not affiliated, associated, or in any way connected
          with the owners of the amplifier brands mentioned. All trademarks and
          copyrights belong to their respective owners. The use of these names
          is purely for descriptive and comparative purposes in the context of
          Kemper Profiles and Tonex models, which aim to replicate the sonic
          qualities of the original amplifiers.
        </p>
      </section>
    </div>
  );
};

export default Tonex;
